import React, { Component } from 'react'
import Select from 'react-select'

class TipoFormularioSecuenciaPaso extends Component {
	render() {
		let paso = this.props.paso;
		let idsUsados = this.props.idsUsados || [];
		let tipoFormularioOptions = this.props.tipoFormularioOptions || [];
		let opcionesDisponibles = tipoFormularioOptions.filter((opcion) => opcion.value === paso.tipo_formulario_id || idsUsados.indexOf(opcion.value) === -1);
		let opcionSeleccionada = tipoFormularioOptions.find((opcion) => opcion.value === paso.tipo_formulario_id);
		return (
			<div className="card pull-up">
				<div className="card-content">
					<div className="card-body py-2">
						<div style={{display: 'flex', alignItems: 'center'}}>
							<div style={{flex: '1 1 auto', minWidth: 0}}>
								<Select
									options={opcionesDisponibles}
									valueKey="value"
									labelKey="label"
									value={paso.tipo_formulario_id}
									onChange={(e) => this.props.handleChange(this.props.index, e ? e.value : null)}
									disabled={this.props.disabled}
									multi={false}
								/>
								{opcionSeleccionada && opcionSeleccionada.descripcion &&
									<small className="text-muted">{opcionSeleccionada.descripcion}</small>
								}
							</div>
							{!this.props.disabled &&
								<span className="text-danger cursor-pointer ml-2" onClick={() => this.props.handleDelete(this.props.index)}>
									<i className="fa fa-trash fa-lg"></i>
								</span>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default TipoFormularioSecuenciaPaso;
